/**
 * AppShell Component
 * 
 * 메인 레이아웃 - Sidebar + Main Content
 */

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function AppShell() {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}

export default AppShell;
